<template>
  <el-popover v-model="visible" placement="bottom-start" :width="width" trigger="focus" :popper-append-to-body="false" @show="showHandle">
    <el-input slot="reference" v-model="keyword" placeholder="" size="small" @input="remoteQueryDebounce" @blur="blurHandle" />
    <el-table :data="gridData" border :height="height" size="mini" :show-header="showHeader" @row-click="remoteSelect">
      <slot name="columns"></slot>
    </el-table>
  </el-popover>
</template>
<script>
/*
当 已查询，没数据/未选择 时，失去焦点时，置空keyword。 以防止 提交时，把无效数据提交上去
*/
import debounce from 'lodash/debounce'
export default {
  name: 'RemoteSelect',
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 250
    },
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      isFirstLoad: true,
      isInputQuery: false, // 是输入查询
      isQueriedButNotSelected: false, // 已查询，但是未选择
      gridData: [],
      keyword: ''
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.keyword = newVal
    }
  },
  created() {
    this.keyword = this.value
  },
  mounted() {},
  methods: {
    showHandle() {
      if (this.isFirstLoad) {
        // 如果是第一次显示，则主动查询一遍
        this.isFirstLoad = false
        this.remoteQuery()
      }
    },
    blurHandle() {
      if (this.isQueriedButNotSelected) {
        this.keyword = ''
      }
      this.$emit('update:value', this.keyword)
    },
    remoteQuery() {
      this.isQueriedButNotSelected = true
      if (!this.isInputQuery) this.isInputQuery = true

      this.loading = true
      this.$emit('remoteQuery', this.keyword, (data) => {
        this.gridData = data
        this.loading = false
      })
    },
    remoteQueryDebounce: debounce(function () {
      this.remoteQuery()
    }, 500),
    remoteSelect(row) {
      this.$emit('remoteSelect', row, (data) => {
        this.$emit('update:value', data)
        this.keyword = data
        this.visible = false
        this.isQueriedButNotSelected = false
      })
    }
  }
}
</script>
